import React from "react";
import { useState, useEffect } from "react";
import JsonData from "../data/data.json";
import { About } from "./about";
import { Contact } from "./contact";
import CustomLoader from "./customLoader";
import DetectionResults from "./results";

const Detector = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [traits, setTraits] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  const fetchWithTimeout = async (resource, options = {}) => {
    const { timeout = 8000 } = options;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    });

    clearTimeout(id);
    return response;
  };

  const fetchTweets = async (handle) => {
    try {
      const response = await fetchWithTimeout(
        `https://personality-backend-node.herokuapp.com/analyse/${handle}`,
        { timeout: 60000 }
      );
      return response.json();
    } catch (err) {
      console.log(err.message);
    }
  };

  const prediction = async (tweets) => {
    const response = await fetchWithTimeout(`${window.mlUrl}/?data=${tweets}`, {
      timeout: 60000000,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: {
        data: tweets,
      },
    });
    return response.json();
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);

    try {
      e.preventDefault();
      const handle = e.target[0].value;
      const tweets = await fetchTweets(handle);
      const traits = await prediction(tweets);
      setTraits(traits);
      setShow(true);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <About
        text="Detection Tool"
        data={landingPageData.Detector}
        comp={show && <DetectionResults traits={traits} />}
      >
        {isLoading && <CustomLoader />}
        <form validate="true" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <input
                  type="text"
                  id="username"
                  name="username"
                  className="form-control"
                  placeholder="Enter your handle"
                  required
                />
                <p className="help-block text-danger"></p>
              </div>
            </div>
          </div>
          <div id="success"></div>
          <button
            type="submit"
            className="btn btn-custom"
            style={{ cursor: "pointer" }}
          >
            Submit
          </button>
        </form>
      </About>
      <Contact data={landingPageData.data} />
    </>
  );
};

export default Detector;
